<template>
  <v-card
    flat
    class="ma-4 custom-card-no-active rounded-xl"
    min-width="272px"
    :max-width="$vuetify.breakpoint.xsOnly ? 300 : 315"
    @click="options.toggle"
    :color="options.active ? undefined : 'white'"
  >
    <!-- min-height="270" -->
    <!-- color="white" -->
    <!-- 340px -->
    <v-card-text
      class="rounded-xl mb-3 rounded-br-0 pa-6 p-relative custom-box-shadow"
    >
      <div class="text-body-2 black--text font-weight-medium">
        {{ item.title }}
      </div>
      <v-rating
        class="mt-2"
        :value="5"
        readonly
        color="yellow darken-1"
        background-color="yellow darken-1"
        dense
        small
      ></v-rating>
      <div class="triangle"></div>
    </v-card-text>
    <v-card-text class="person pl-3 px-0 d-flex align-center">
      <div class="avatar">
        <!-- <div class="avatar-border"> -->
          <v-avatar size="65" :class="{ 'v-box-shadow': options.active }">
            <!-- :src="
                  require('../../assets/imgs/home/section-4/' + item.img + '.png')
                " -->
            <v-img src="@/assets/imgs/ESay/person.png" max-width="60" contain>
              <template #placeholder>
                <v-row class="fill-height" align="center" justify="center">
                  <v-progress-circular
                    width="2"
                    indeterminate
                    size="25"
                    color="grey darken-2"
                  />
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        <!-- </div> -->
      </div>
      <div class="person-info" style="max-width:60%">
        <v-list-item-title
          class="
            text-h6 text-lg-h5
            secondary--text
            text--darken-1
            font-weight-bold
            person-name
          "
        >
          {{ item.name }}
        </v-list-item-title>
        <!-- <div class="text-body-2 font-weight-bold person-country">
          {{ item.country }}
        </div> -->
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["item", "options"],
};
</script>
<style lang="scss" scoped>
.triangle {
  background-image: url("@/assets/imgs/ESay/arrow-ar.png");
  background-size: contain;
  width: 40px;
  height: 40px;
  position: absolute;
  right: -7px;
  bottom: -40px;
}
.custom-box-shadow {
  box-shadow: 0px 0px 8px #00000052 !important;
}
.p-relative {
  position: relative;
}
.person {
  gap: 10px;
}
.avatar-border {
  border: 2px solid black;
  border-radius: 50%;
}
</style>
